// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".g-auth{font-family:PingFang SC;position:relative;height:480px;padding-top:80px;background:#fff}.g-auth--hide-footer{padding:58px 0 10px 0}.g-auth *{box-sizing:border-box}.g-auth .g-auth--qq{display:none}", ""]);
// Exports
module.exports = exports;
